window._ = require('lodash');

window.$ = window.jQuery = require('jquery');

// Vendor
require('bootstrap');
require('devbridge-autocomplete');
require('jquery-mask-plugin');
require('@fortawesome/fontawesome');
require('@fortawesome/fontawesome-pro-regular');

import Vue from 'vue'
window.Vue = Vue;

// Components
Vue.component('biological-usages', () => import('./components/BiologicalUsages.vue'));
Vue.component('biological-usage-bulk-creator', () => import('./components/BiologicalUsageBulkCreator.vue'));
Vue.component('biological-usage-image', () => import('./components/BiologicalUsageImage.vue'));

// Modules
require('./modules/biological-autocomplete');
require('./modules/date-of-birth');
require('./modules/address');

// Vue
const app = new Vue({
    el: '#app'
});

// https://github.com/vuejs/vue/issues/7251
$(function () {
    $('input[type=date]').each(function () {
        var val = $(this).val();
        $(this).val('').val(val);
    });

    $('[data-href]').click(function () {
        window.location.href = $(this).data('href');
    })
});
